import { css } from 'styled-components';

export const getSizeValue = (size) => {
	switch (size) {
		case 'xl':
			return '1.6rem';
		case 'l':
			return '1.4rem';
		case 'normal':
			return '1.082rem';
		case 'xs':
			return '0.75rem';
		default:
			return '1rem';
	}
};

export const mapCSS = ({ width, height, paddingX, paddingY, size, margin }) => {
	const fontSize = getSizeValue(size);
	const base = css`
		font-size: ${fontSize};
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		cursor: pointer;
		text-align: center;
		margin: ${margin};
	`;
	let styles = null;
	if (width === 'auto' || height === 'auto') {
		styles = css`
			padding: ${paddingY} ${paddingX};
		`;
	} else {
		styles = css`
			width: ${width};
			height: ${height};
		`;
	}
	return css`
		${base}
		${styles}
	`;
};
